import { ethers } from "ethers";
import { evmNetworkDefinition } from "../config/evmNetworks";
import { createBaseReadProvider } from "../utils/base-read-provider";

/** Recovery reads never pass through an app proxy or attach an app token. */
function directUrl(value: string): string {
  const url = new URL(value);
  if (
    url.protocol !== "https:" ||
    url.username ||
    url.password ||
    url.hash ||
    /(^|\.)(stealthos\.xyz|onrender\.com|vercel\.app)$/i.test(url.hostname)
  )
    throw new Error("Recovery requires an independent HTTPS blockchain RPC.");
  return url.href;
}

const evmProviders = new Map<string, ethers.JsonRpcProvider>();

export function getDirectEvmRecoveryProvider(
  chainId: number,
  rpcUrl?: string,
): ethers.JsonRpcProvider {
  const configured = evmNetworkDefinition(chainId);
  const url = directUrl(rpcUrl ?? configured?.publicRpcUrls[0] ?? "");
  const key = `${chainId}:${url}`;
  let provider = evmProviders.get(key);
  if (!provider) {
    // This provider checks eth_chainId and permits public reads only.
    provider = createBaseReadProvider(url, chainId);
    evmProviders.set(key, provider);
  }
  return provider;
}
